export default "/shell-coin-lighter-logo.8bdae9a850710e70efaaeb3cceb36f42.svg";